import { useEffect, useState } from "react";
import { useInput } from "hooks";
import AutocompleteFreeText from "components/AutocompleteFreeText";
import { WEB_PROMOTIONS_INCENTIVE_PREDICTIVE_TEXT } from "config";

export const IncentiveWebPromotionsTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const freeText = useInput("")
  const [incentiveText, setIncentiveText] = useState(value)

  const handleUpdateValue = (e) => {
    setIncentiveText(`${e}`);
  };

  useEffect(() => {
    onChange(incentiveText);
  }, [incentiveText])

  return (
    <div className="p-2 d-flex justify-content-between align-items-center">
      <AutocompleteFreeText label="Free Text" value={freeText.value}
        data={WEB_PROMOTIONS_INCENTIVE_PREDICTIVE_TEXT}
        onChange={(e) => {
          freeText.setValue(e);
          handleUpdateValue(e)
        }}
      />
    </div>
  );
};